import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, opacity = 1, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    height={`${size}`}
    width={`${size}`}
    fill="none"
    {...props}
  >
    <g stroke={color} strokeWidth="2" opacity={opacity}>
      <path d="M12.256 7 8 11l4.256 4" />
      <path d="M9.06403 11h3.448c2.20913 0 3.99997 1.79086 3.99997 4v2" />
    </g>
  </svg>
);
